import { render, staticRenderFns } from "./incourse_marks_entry_form.vue?vue&type=template&id=1c042128&"
import script from "./incourse_marks_entry_form.vue?vue&type=script&lang=js&"
export * from "./incourse_marks_entry_form.vue?vue&type=script&lang=js&"
import style0 from "./incourse_marks_entry_form.vue?vue&type=style&index=0&id=1c042128&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports